import React from "react";
import { Navigate } from "react-router-dom";

//Dashboard
import DashboardCrm from "../pages/DashboardCrm";

//CampSite
import SiteForm from "../pages/CampSite/Site";

//Reservation
import ReservationProducts from "../pages/Reservations/ReservationProducts";
import ReservationAddProduct from "../pages/Reservations/ReservationProducts/ReservationAddProduct";
import ReservationProductDetail from "../pages/Reservations/ReservationProducts/ReservationProductDetail";
import ReservationList from "../pages/Reservations/ReservationList";
import CanceledReservationList from "../pages/Reservations/CanceledReservationList";
import ReservationCancel from "../pages/Reservations/ReservationCancel";
import ReservationCalendar from "../pages/Reservations/ReservationCalendar";
import FreeSeatAssignmentPage from "../pages/Reservations/FreeSeatAssignment";
import GroupReservationRequestsPage from "../pages/Reservations/GroupReservationRequests";
import GroupReservationRequestCreatePage from "../pages/Reservations/GroupReservationRequests/GroupReservationRequestCreate";
import GroupReservationRequestDetailPage from "../pages/Reservations/GroupReservationRequests/GroupReservationRequestDetail";
import GroupReservationOptionProductsPage from "../pages/Reservations/GroupReservationOptionProducts";
import GroupReservationAgencyLinksPage from "../pages/Reservations/GroupReservationAgencyLinks";
import PrivateOffersPage from "../pages/Reservations/PrivateOffers";
import MarketerInfoPage from "../pages/Marketer/MarketerInfoPage";

//Ticket
import TicketProducts from "../pages/Tickets/TicketProducts";
import TicketProductForm from "../pages/Tickets/TicketProducts/TicketProductForm";
import TicketList from "../pages/Tickets/Transactions";
import CanceledTicketList from "../pages/Tickets/TransactionsCanceled";
import TicketGiftList from "../pages/Tickets/TicketGiftList";

//Coupon
import CouponList from "../pages/Coupons/Coupon";
import CouponForm from "../pages/Coupons/Coupon/CouponForm";
import BenefitRuleList from "../pages/Coupons/BenefitRule";
import BenefitRuleForm from "../pages/Coupons/BenefitRule/BenefitRuleForm";
import UserCouponList from "../pages/Coupons/UserCoupon/UserCouponList";
import UserSendCoupon from "../pages/Coupons/Coupon/UserSendCoupon";
import CouponBookRuleList from "../pages/Coupons/CouponBook/CouponBookRuleList";
import CouponBookForm from "../pages/Coupons/CouponBook/CouponBookForm";
import B2BCouponList from "../pages/Coupons/B2BCoupon/B2BCouponStockList";

//Voucher
import VoucherList from "../pages/Vouchers/VoucherList";
import VoucherForm from "../pages/Vouchers/VoucherList/VoucherForm";
import UserVoucherList from "../pages/Vouchers/UserVoucherList";
import SendVoucherCoupon from "../pages/Vouchers/SendVoucherCoupon";

//User
import UserList from "../pages/Users/UserList";
import MemberListPage from "../pages/member/MemberListPage";
import MemberInvitationListPage from "../pages/member/MemberInvitationListPage";
import MemberInvitePage from "../pages/member/MemberInvitePage";
import InviteConfirmPage from "../pages/member/InviteConfirmPage";
import InviteRegisterPage from "../pages/member/InviteRegisterPage";
import AuthSessionManagementPage from "../pages/member/AuthSessionManagementPage";

//LogIn
import KakaoPage from "../pages/Authentication/KakaoPage";
import SsoPage from "../pages/Authentication/SsoPage";
import NaverPage from "../pages/Authentication/NaverPage";

//Calendar
// Email box

//CHat

// Project

//Task

//Crm Pages

//Invoices

// Support Tickets

// //Ecommerce Pages

// Base Ui

// Widgets

//Forms
// import FormWizard from "../pages/Forms/FormWizard/FormWizard";

//Tables

//Icon pages

//Maps

//AuthenticationInner pages
//pages



//login
import Login from "../pages/Authentication/Login";

// Landing Index
import OnePage from "../pages/Landing/OnePage";

// User Profile
import Profile from "../pages/Users/Profile";
import ReservationGiftList from "../pages/Reservations/ReservationGiftList";
import ReservationOptionList from "../pages/Reservations/ReservationOptionList";
import OptionProductList from "../pages/Reservations/OptionProductList";
import OptionAddProduct from "../pages/Reservations/OptionProductList/OptionAddProduct";

import UserDetail from "../pages/Users/UserDetail";
import UserVoucherGiftList from "../pages/Vouchers/UserVoucherGiftList";
import ReservationAddItem from "../pages/Reservations/ReservationList/ReservationAddItem";
import StatisticsAdjustment from "../pages/Statistics/StatisticsAdjustment";
import DailyReservationList from "../pages/Reservations/DailyReservationList";
import SalesStatistics from "../pages/Statistics/SalesStatistics";
import CoreMetrics from "../pages/Statistics/CoreMetrics";

import PreCouponList from "../pages/PreCoupons/PreCouponProducts";
import PreCouponForm from "../pages/PreCoupons/PreCouponProducts/PreCouponForm";
import UserPreCouponList from "../pages/PreCoupons/PreCouponList";
import ReservationSendCoupon from "../pages/PreCoupons/SendReservationCoupon";

import PushAppNotification from "../pages/Notification/PushAppNotification";
import NotificationCenter from "../pages/Notification/NotificationCenter";

// supply
import SupplyList from "../pages/Supply/SupplyList";
import SupplyProducts from "../pages/Supply/SupplyProducts";
import SupplyProductForm from "../pages/Supply/SupplyProducts/SupplyProductForm";
import SupplyBasket from "../pages/Supply/SupplyCart";
import SupplyAdmin from "../pages/Supply/SupplyAdmin";

// shop
import ShoppingProducts from "../pages/Shopping/ShoppingProducts";
import ShoppingProductForm from "../pages/Shopping/ShoppingProducts/ShoppingProductForm";
import ShoppingAdmin from "../pages/Shopping/ShoppingAdmin";
import TableOrderMenuCategories from "../pages/TableOrder/MenuCategories";
import TableOrderMenus from "../pages/TableOrder/Menus";
import TableOrderTables from "../pages/TableOrder/Tables";
import TableOrderOrders from "../pages/TableOrder/Orders";
import TableOrderMenuCategoryForm from "../pages/TableOrder/MenuCategories/Form";
import TableOrderMenuForm from "../pages/TableOrder/Menus/Form";
import TableOrderTableGroups from "../pages/TableOrder/TableGroups";
import TableOrderTableGroupForm from "../pages/TableOrder/TableGroups/Form";
import TableOrderTableForm from "../pages/TableOrder/Tables/Form";
import TableOrderOrderDetail from "../pages/TableOrder/Orders/Detail";
import SeatManagement from "../pages/TableOrder/SeatManagement";
import KitchenLauncher from "../pages/TableOrder/KitchenLauncher";
import TableOrderTerminals from "../pages/TableOrder/Terminals";
import TableOrderCashierPOS from "../pages/TableOrder/POS";

import ComplianceArticleList from "../pages/Compliance/ComplianceArticleList";
import ReservationOptionAddItem from "../pages/Reservations/ReservationOptionList/ReservationOptionAddItem";
import B2BCouponForm from "../pages/Coupons/B2BCoupon/B2BCouponStockForm";
import NotificationList from "../pages/Notification/NotificationList";
import B2BVoucherList from "../pages/Vouchers/B2BVoucher/B2BVoucherStockList";
import B2BVoucherForm from "../pages/Vouchers/B2BVoucher/B2BVoucherStockForm";

import {
  MessageSend,
  MessageHistory,
  TemplateManagement,
  SenderManagement,
  SiteConfiguration,
} from "../pages/Messaging";

import { NoticeList, AnnounceList, NoticeForm } from "../pages/Notice";

//User
import B2BPreCouponList from "../pages/PreCoupons/B2BPreCoupon/B2BPreCouponStockList";
import B2BPreCouponForm from "../pages/PreCoupons/B2BPreCoupon/B2BPreCouponStockForm";
import SeatMap from "../pages/Reservations/ReservationProducts/seatmap";
import UserOrderTotalList from "../pages/Orders/UserOrderTotalList";
import OrderErrorHandlingList from "../pages/Orders/OrderErrorHandlingList";
import SharedUiDevPage from "../pages/Dev/SharedUi";
import SiteBillingInvoicesPage from "../pages/SiteBilling/SiteBillingInvoicesPage";
import SiteBillingSitesStatusPage from "../pages/SiteBilling/SiteBillingSitesStatusPage";

const blockWhenSitePaused = (route) => ({ ...route, blockedWhenSitePaused: true });

const authProtectedRoutes = [
  // custom
  { path: "/site-form", component: SiteForm },

  { path: "/compliance", component: ComplianceArticleList },

  blockWhenSitePaused({ path: "/reservation-products", component: ReservationProducts }),
  blockWhenSitePaused({ path: "/reservation-product-details/:id", component: ReservationProductDetail }),
  blockWhenSitePaused({ path: "/reservation-add-product/:id", component: ReservationAddProduct }),
  blockWhenSitePaused({ path: "/reservation-add-item", component: ReservationAddItem }),
  blockWhenSitePaused({ path: "/reservation-add-item/:id", component: ReservationAddItem }),
  blockWhenSitePaused({ path: "/reservation-option-add-item", component: ReservationOptionAddItem }),
  blockWhenSitePaused({ path: "/reservation-option-add-item/:id", component: ReservationOptionAddItem }),
  blockWhenSitePaused({ path: "/daily-reservation-list", component: DailyReservationList }),
  blockWhenSitePaused({ path: "/free-seat-assignment", component: FreeSeatAssignmentPage }),
  blockWhenSitePaused({ path: "/reservation-list", component: ReservationList }),
  blockWhenSitePaused({ path: "/canceled-reservation-list", component: CanceledReservationList }),
  blockWhenSitePaused({ path: "/reservation-cancel/:id", component: ReservationCancel }),
  blockWhenSitePaused({ path: "/reservation-calendar/", component: ReservationCalendar }),
  blockWhenSitePaused({ path: "/reservation-gift-list", component: ReservationGiftList }),
  blockWhenSitePaused({ path: "/reservation-option-list", component: ReservationOptionList }),
  blockWhenSitePaused({ path: "/reservation-send-coupon", component: ReservationSendCoupon }),
  blockWhenSitePaused({ path: "/private-offers", component: PrivateOffersPage, requiredCapability: "site_owner" }),
  blockWhenSitePaused({ path: "/group-reservation-requests", component: GroupReservationRequestsPage }),
  blockWhenSitePaused({ path: "/group-reservation-requests/new", component: GroupReservationRequestCreatePage }),
  blockWhenSitePaused({ path: "/group-reservation-requests/:id", component: GroupReservationRequestDetailPage }),
  blockWhenSitePaused({ path: "/group-reservation-option-products", component: GroupReservationOptionProductsPage }),
  blockWhenSitePaused({ path: "/group-reservation-agency-links", component: GroupReservationAgencyLinksPage }),
  blockWhenSitePaused({ path: "/voucher-send-coupon", component: SendVoucherCoupon }),

  blockWhenSitePaused({ path: "/seat-map", component: SeatMap }),

  //option
  blockWhenSitePaused({ path: "/option-product-list", component: OptionProductList }),
  blockWhenSitePaused({ path: "/option-add-product/:id", component: OptionAddProduct }),

  blockWhenSitePaused({ path: "/ticket-products", component: TicketProducts }),
  blockWhenSitePaused({ path: "/ticket-product-form/:id", component: TicketProductForm }),
  blockWhenSitePaused({ path: "/ticket-list", component: TicketList }),
  blockWhenSitePaused({ path: "/canceled-ticket-list", component: CanceledTicketList }),
  blockWhenSitePaused({ path: "/ticket-gift-list", component: TicketGiftList }),

  blockWhenSitePaused({ path: "/coupon-list", component: CouponList }),
  blockWhenSitePaused({ path: "/coupon-form/:id", component: CouponForm }),
  blockWhenSitePaused({ path: "/benefit-rule-list", component: BenefitRuleList }),
  blockWhenSitePaused({ path: "/benefit-rule-form/:id", component: BenefitRuleForm }),
  blockWhenSitePaused({ path: "/couponbook-list", component: CouponBookRuleList }),
  blockWhenSitePaused({ path: "/couponbook-form/:id", component: CouponBookForm }),
  blockWhenSitePaused({ path: "/user-coupon-list", component: UserCouponList }),
  blockWhenSitePaused({ path: "/user-send-coupon", component: UserSendCoupon }),
  blockWhenSitePaused({ path: "/b2b-coupon-list", component: B2BCouponList}),
  blockWhenSitePaused({ path: "/b2b-coupon-form/:id", component: B2BCouponForm }),

  blockWhenSitePaused({ path: "/voucher-list", component: VoucherList }),
  blockWhenSitePaused({ path: "/voucher-form/:id", component: VoucherForm }),
  blockWhenSitePaused({ path: "/user-voucher-list", component: UserVoucherList }),
  blockWhenSitePaused({ path: "/user-voucher-gift-list", component: UserVoucherGiftList }),
  blockWhenSitePaused({ path: "/b2b-voucher-list", component: B2BVoucherList}),
  blockWhenSitePaused({ path: "/b2b-voucher-form/:id", component: B2BVoucherForm }),

  blockWhenSitePaused({ path: "/precoupon-list", component: PreCouponList }),
  blockWhenSitePaused({ path: "/precoupon-form/:id", component: PreCouponForm }),
  blockWhenSitePaused({ path: "/user-precoupon-list", component: UserPreCouponList }),
  blockWhenSitePaused({ path: "/b2b-precoupon-list", component: B2BPreCouponList}),
  blockWhenSitePaused({ path: "/b2b-precoupon-form/:id", component: B2BPreCouponForm }),

  { path: "/supply-list", component: SupplyList },
  { path: "/supply-product-list", component: SupplyProducts },
  { path: "/supply-product-form/:id", component: SupplyProductForm, requiredCapability: "site_owner" },
  { path: "/supply-basket-list", component: SupplyBasket },
  { path: "/supply-admin", component: SupplyAdmin, requiredCapability: "site_owner" },

  blockWhenSitePaused({ path: "/shopping-product-list", component: ShoppingProducts }),
  blockWhenSitePaused({ path: "/shopping-product-form/:id", component: ShoppingProductForm }),
  blockWhenSitePaused({ path: "/shopping-admin", component: ShoppingAdmin }),
  { path: "/table-order/menu-categories", component: TableOrderMenuCategories },
  { path: "/table-order/menu-category-form/:id", component: TableOrderMenuCategoryForm },
  { path: "/table-order/menus", component: TableOrderMenus },
  { path: "/table-order/menu-form/:id", component: TableOrderMenuForm },
  { path: "/table-order/table-groups", component: TableOrderTableGroups },
  { path: "/table-order/table-group-form/:id", component: TableOrderTableGroupForm },
  { path: "/table-order/tables", component: TableOrderTables },
  { path: "/table-order/table-form/:id", component: TableOrderTableForm },
  { path: "/table-order/seat-management", component: SeatManagement },
  { path: "/table-order/pos", component: TableOrderCashierPOS },
  { path: "/table-order/orders", component: TableOrderOrders },
  { path: "/table-order/kitchen-launcher", component: KitchenLauncher },
  { path: "/table-order/terminals", component: TableOrderTerminals },
  { path: "/table-order/order-detail/:id", component: TableOrderOrderDetail },

  { path: "/user-list", component: UserList },
  { path: "/user/:id", component: UserDetail },
  { path: "/profile", component: Profile },
  { path: "/member-list", component: MemberListPage, requiredCapability: "member_manage" },
  { path: "/member-invitation-list", component: MemberInvitationListPage, requiredCapability: "member_manage" },
  { path: "/member-invite", component: MemberInvitePage, requiredCapability: "member_manage" },
  { path: "/member-auth-sessions", component: AuthSessionManagementPage, requiredCapability: "member_manage" },

  { path: "/dashboard-crm", component: DashboardCrm },
  { path: "/marketer-info", component: MarketerInfoPage, requiredCapability: "marketer" },

  { path: "/sales-statistics", component: SalesStatistics },
  { path: "/core-metrics", component: CoreMetrics },
  { path: "/statistics-adjustment", component: StatisticsAdjustment },
  { path: "/site-billing/invoices", component: SiteBillingInvoicesPage, requiredGlobalAdmin: true },
  { path: "/site-billing/sites-status", component: SiteBillingSitesStatusPage, requiredGlobalAdmin: true },

  { path: "/push-app-notification", component: PushAppNotification },
  { path: "/notification-list", component: NotificationList },
  { path: "/notification-center", component: NotificationCenter },
  { path: "/notification-center/send", component: NotificationCenter },
  { path: "/notification-center/history", component: NotificationCenter },
  { path: "/notification-center/system", component: NotificationCenter },
  { path: "/notification-center/templates", component: NotificationCenter },
  { path: "/notification-center/channels", component: NotificationCenter },
  { path: "/notification-center/hq", component: NotificationCenter, requiredHqAdmin: true },

  // Orders
  { path: "/user-order-total", component: UserOrderTotalList },
  { path: "/order-error-handlings", component: OrderErrorHandlingList },
  { path: "/dev/ui-shared", component: SharedUiDevPage },

  // Messaging
  { path: "/messaging-send", component: MessageSend },
  { path: "/messaging-history", component: MessageHistory },
  { path: "/messaging-templates", component: TemplateManagement },
  { path: "/messaging-senders", component: SenderManagement },
  { path: "/messaging-site-config", component: SiteConfiguration },

  { path: "/notice-list", component: NoticeList },
  { path: "/notice-form/:id", component: NoticeForm },
  { path: "/announce-list", component: AnnounceList },

  // this route should be at the end of all other routes
  // eslint-disable-next-line react/display-name
  {
    path: "/",
    exact: true,
    component: () => <Navigate to="/login" replace />,
  },
];

const publicRoutes = [
  // Authentication Page
  { path: "/login", component: Login },

  { path: "/invite/confirm", component: InviteConfirmPage },
  { path: "/invite/register", component: InviteRegisterPage },
  
  // OAuth Callbacks (must be public)
  { path: "/kakao", component: KakaoPage },
  { path: "/sso", component: SsoPage },
  { path: "/naver", component: NaverPage },
];

export { authProtectedRoutes, publicRoutes };
